import { useState } from 'react'

import { CalendarBlankIcon, XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { DesktopDatePicker } from '@mui/x-date-pickers'
import { InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DatePicker = ({
  value,
  onChange,
  label,
  disabled,
  helperText,
  error,
  inputProps,
  backgroundColor,
  fullWidth,
  clearable,
}) => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  const handleClear = event => {
    event.stopPropagation()
    onChange(null)
  }

  const handleOpen = () => {
    if (!disabled) {
      setOpen(true)
    }
  }

  const showClear = clearable && value && !disabled

  return (
    <DesktopDatePicker
      open={open}
      onOpen={handleOpen}
      onClose={() => setOpen(false)}
      inputFormat="DD/MM/YYYY"
      value={value || null}
      onChange={onChange}
      disabled={disabled}
      components={{
        OpenPickerIcon: () => <CalendarBlankIcon size={16} weight="light" color={theme.colors.text.default} />,
      }}
      renderInput={({ inputRef, inputProps: dateInputProps, InputProps }) => (
        <InputWithLabel
          fullWidth={fullWidth}
          value={dateInputProps.value}
          onChange={dateInputProps.onChange}
          label={label}
          inputRef={inputRef}
          onClick={handleOpen}
          InputProps={{
            ...InputProps,
            endAdornment: (
              <>
                {showClear && (
                  <Styles.ClearButton onClick={handleClear} aria-label="clear date">
                    <XIcon size={14} weight="bold" color={theme.colors.text.subtle} />
                  </Styles.ClearButton>
                )}
                {InputProps?.endAdornment}
              </>
            ),
          }}
          disabled={disabled}
          helperText={helperText}
          error={error}
          inputProps={inputProps}
          backgroundColor={backgroundColor}
          readOnly
        />
      )}
    />
  )
}

export default DatePicker
